import styled from 'styled-components';
import { toRem, baseVariables } from '@marriott/mi-ui-library';

export const StyledTabbedSearchContainer = styled.div`
  background: white;
  border-radius: ${toRem(12)};
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  max-width: ${toRem(900)};
  margin: 0 auto;

  @media ${baseVariables.mediaQuery.tablet} {
    border-radius: ${toRem(16)};
  }
`;

export const StyledTabHeader = styled.div`
  display: flex;
  background: ${baseVariables.color.neutral10};
  padding: ${toRem(4)};
  gap: ${toRem(4)};
`;

export const StyledTab = styled.button<{ $isActive: boolean }>`
  flex: 1;
  padding: ${toRem(12)} ${toRem(24)};
  border: none;
  border-radius: ${toRem(8)};
  font-size: ${baseVariables.font.fontS};
  font-weight: ${baseVariables.font.fontWeightMedium};
  cursor: pointer;
  transition: all 0.2s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${toRem(8)};

  background: ${props => (props.$isActive ? 'white' : 'transparent')};
  color: ${props => (props.$isActive ? baseVariables.color.base20 : baseVariables.color.neutral40)};
  box-shadow: ${props => (props.$isActive ? '0 2px 8px rgba(0, 0, 0, 0.1)' : 'none')};

  &:hover {
    background: ${props => (props.$isActive ? 'white' : baseVariables.color.neutral20)};
  }

  @media ${baseVariables.mediaQuery.tablet} {
    padding: ${toRem(16)} ${toRem(32)};
    font-size: ${baseVariables.font.fontM};
  }
`;

export const StyledTabContent = styled.div`
  padding: ${toRem(24)};

  @media ${baseVariables.mediaQuery.tablet} {
    padding: ${toRem(32)};
  }
`;

export const StyledAISearchContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${toRem(20)};
`;

export const StyledAISearchInput = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: ${baseVariables.color.neutral10};
  border-radius: ${toRem(50)};
  padding: ${toRem(4)};
  border: ${toRem(2)} solid transparent;
  transition: border-color 0.2s ease;

  &:focus-within {
    border-color: ${baseVariables.color.brand};
  }
`;

export const StyledTextInput = styled.input`
  flex: 1;
  border: none;
  background: transparent;
  padding: ${toRem(16)} ${toRem(24)};
  font-size: ${baseVariables.font.fontM};
  color: ${baseVariables.color.base20};

  &::placeholder {
    color: ${baseVariables.color.neutral40};
  }

  &:focus {
    outline: none;
  }
`;

export const StyledSearchButton = styled.button`
  background: ${baseVariables.color.brand};
  color: white;
  border: none;
  border-radius: ${toRem(50)};
  padding: ${toRem(12)} ${toRem(24)};
  font-size: ${baseVariables.font.fontS};
  font-weight: ${baseVariables.font.fontWeightMedium};
  cursor: pointer;
  transition: all 0.2s ease;
  white-space: nowrap;

  &:hover {
    background: ${baseVariables.color.brandDark};
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media ${baseVariables.mediaQuery.tablet} {
    padding: ${toRem(16)} ${toRem(32)};
    font-size: ${baseVariables.font.fontM};
  }
`;

export const StyledVoiceButton = styled.button`
  background: white;
  border: ${toRem(1)} solid ${baseVariables.color.neutral30};
  border-radius: 50%;
  width: ${toRem(40)};
  height: ${toRem(40)};
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
  margin-right: ${toRem(8)};

  &:hover {
    background: ${baseVariables.color.neutral10};
    border-color: ${baseVariables.color.brand};
  }

  svg {
    width: ${toRem(16)};
    height: ${toRem(16)};
    fill: ${baseVariables.color.neutral40};
  }
`;

export const StyledSuggestions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${toRem(8)};
  margin-top: ${toRem(16)};
`;

export const StyledSuggestionChip = styled.button`
  background: white;
  border: ${toRem(1)} solid ${baseVariables.color.neutral30};
  border-radius: ${toRem(20)};
  padding: ${toRem(8)} ${toRem(16)};
  font-size: ${baseVariables.font.fontXs};
  color: ${baseVariables.color.neutral40};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: ${baseVariables.color.neutral10};
    border-color: ${baseVariables.color.brand};
    color: ${baseVariables.color.base20};
  }

  @media ${baseVariables.mediaQuery.tablet} {
    font-size: ${baseVariables.font.fontS};
    padding: ${toRem(10)} ${toRem(20)};
  }
`;

export const StyledQuickSearchContainer = styled.div`
  /* SearchForm will handle its own styling */
`;
